export const constants = {
  INDEX: {
    REQUEST: 'PUBLICACIONES_INDEX_REQUEST',
    SUCCESS: 'PUBLICACIONES_INDEX_SUCCESS',
    FAILURE: 'PUBLICACIONES_INDEX_FAILURE',
  },
  GET_ITEM: {
    REQUEST: 'PUBLICACIONES_GET_ITEM_REQUEST',
    SUCCESS: 'PUBLICACIONES_GET_ITEM_SUCCESS',
    FAILURE: 'PUBLICACIONES_GET_ITEM_FAILURE',
  },
  ADD_ITEM: {
    REQUEST: 'PUBLICACIONES_ADD_ITEM_REQUEST',
    SUCCESS: 'PUBLICACIONES_ADD_ITEM_SUCCESS',
    FAILURE: 'PUBLICACIONES_ADD_ITEM_FAILURE',
  },
  EDIT_ITEM: {
    REQUEST: 'PUBLICACIONES_EDIT_ITEM_REQUEST',
    SUCCESS: 'PUBLICACIONES_EDIT_ITEM_SUCCESS',
    FAILURE: 'PUBLICACIONES_EDIT_ITEM_FAILURE',
  },
  ADD_FORM: {
    REQUEST: 'PUBLICACIONES_ADD_FORM_REQUEST',
    SUCCESS: 'PUBLICACIONES_ADD_FORM_SUCCESS',
    FAILURE: 'PUBLICACIONES_ADD_FORM_FAILURE',
  },
  EDIT_FORM: {
    REQUEST: 'PUBLICACIONES_EDIT_FORM_REQUEST',
    SUCCESS: 'PUBLICACIONES_EDIT_FORM_SUCCESS',
    FAILURE: 'PUBLICACIONES_EDIT_FORM_FAILURE',
  },
  REMOVE_ITEM: {
    REQUEST: 'PUBLICACIONES_REMOVE_ITEM_REQUEST',
    SUCCESS: 'PUBLICACIONES_REMOVE_ITEM_SUCCESS',
    FAILURE: 'PUBLICACIONES_REMOVE_ITEM_FAILURE',
  },
  UPDATE_ITEM: {
    REQUEST: 'PUBLICACIONES_UPDATE_ITEM_REQUEST',
    SUCCESS: 'PUBLICACIONES_UPDATE_ITEM_SUCCESS',
    FAILURE: 'PUBLICACIONES_UPDATE_ITEM_FAILURE',
  }
};
